var map = {
	"./API/Index": 16650,
	"./API/Index.vue": 16650,
	"./Admin/Bundle/Edit": 14947,
	"./Admin/Bundle/Edit.vue": 14947,
	"./Admin/Bundle/Index": 48142,
	"./Admin/Bundle/Index.vue": 48142,
	"./Admin/Dashboard": 58155,
	"./Admin/Dashboard.vue": 58155,
	"./Admin/Incoming/DeliveryReceipt/Create": 66859,
	"./Admin/Incoming/DeliveryReceipt/Create.vue": 66859,
	"./Admin/Incoming/DeliveryReceipt/Edit": 48244,
	"./Admin/Incoming/DeliveryReceipt/Edit.vue": 48244,
	"./Admin/Incoming/DeliveryReceipt/Index": 78983,
	"./Admin/Incoming/DeliveryReceipt/Index.vue": 78983,
	"./Admin/Incoming/Purchase/Create": 82279,
	"./Admin/Incoming/Purchase/Create.vue": 82279,
	"./Admin/Incoming/Purchase/Edit": 13430,
	"./Admin/Incoming/Purchase/Edit.vue": 13430,
	"./Admin/Incoming/Purchase/Index": 14908,
	"./Admin/Incoming/Purchase/Index.vue": 14908,
	"./Admin/Item/Edit": 9124,
	"./Admin/Item/Edit.vue": 9124,
	"./Admin/Item/Index": 93797,
	"./Admin/Item/Index.vue": 93797,
	"./Admin/Item/ItemGroup/Create": 29798,
	"./Admin/Item/ItemGroup/Create.vue": 29798,
	"./Admin/Item/ItemGroup/Edit": 66884,
	"./Admin/Item/ItemGroup/Edit.vue": 66884,
	"./Admin/Item/ItemGroup/Index": 76758,
	"./Admin/Item/ItemGroup/Index.vue": 76758,
	"./Admin/Order/Index": 85441,
	"./Admin/Order/Index.vue": 85441,
	"./Admin/Product/Edit": 38861,
	"./Admin/Product/Edit.vue": 38861,
	"./Admin/Product/Index": 95292,
	"./Admin/Product/Index.vue": 95292,
	"./Admin/PurchaseItemStock/Create": 64402,
	"./Admin/PurchaseItemStock/Create.vue": 64402,
	"./Admin/PurchaseItems/Index": 37740,
	"./Admin/PurchaseItems/Index.vue": 37740,
	"./Admin/Questions/Index": 17598,
	"./Admin/Questions/Index.vue": 17598,
	"./Admin/Settings/Tax/Index": 13363,
	"./Admin/Settings/Tax/Index.vue": 13363,
	"./Admin/Statistics/Contract": 71162,
	"./Admin/Statistics/Contract.vue": 71162,
	"./Admin/Statistics/Show": 44936,
	"./Admin/Statistics/Show.vue": 44936,
	"./Admin/Teams/Edit": 77815,
	"./Admin/Teams/Edit.vue": 77815,
	"./Admin/Teams/Index": 21398,
	"./Admin/Teams/Index.vue": 21398,
	"./Admin/User/Index": 46487,
	"./Admin/User/Index.vue": 46487,
	"./Admin/Warehouse/Article/Index": 84172,
	"./Admin/Warehouse/Article/Index.vue": 84172,
	"./Admin/Warehouse/Index": 95446,
	"./Admin/Warehouse/Index.vue": 95446,
	"./Admin/Warehouse/Show": 19128,
	"./Admin/Warehouse/Show.vue": 19128,
	"./Auth/ConfirmPassword": 88913,
	"./Auth/ConfirmPassword.vue": 88913,
	"./Auth/ForgotPassword": 73295,
	"./Auth/ForgotPassword.vue": 73295,
	"./Auth/Login": 81693,
	"./Auth/Login.vue": 81693,
	"./Auth/ResetPassword": 93801,
	"./Auth/ResetPassword.vue": 93801,
	"./Auth/TwoFactorChallenge": 95578,
	"./Auth/TwoFactorChallenge.vue": 95578,
	"./Auth/VerifyEmail": 65538,
	"./Auth/VerifyEmail.vue": 65538,
	"./Catalog/BCA": 64004,
	"./Catalog/BCA.vue": 64004,
	"./Catalog/Index": 98074,
	"./Catalog/Index.vue": 98074,
	"./Catalog/PVC": 14407,
	"./Catalog/PVC.vue": 14407,
	"./Catalog/SDL": 13873,
	"./Catalog/SDL.vue": 13873,
	"./Catalog/Show": 87578,
	"./Catalog/Show.vue": 87578,
	"./Contract/Enlargement/Create": 69498,
	"./Contract/Enlargement/Create.vue": 69498,
	"./Contract/Enlargement/Index": 90908,
	"./Contract/Enlargement/Index.vue": 90908,
	"./Contract/Fulfillment/Create": 10750,
	"./Contract/Fulfillment/Create.vue": 10750,
	"./Contract/Fulfillment/Index": 37040,
	"./Contract/Fulfillment/Index.vue": 37040,
	"./Contract/Fulfillment/Show": 48801,
	"./Contract/Fulfillment/Show.vue": 48801,
	"./Contract/Index": 79351,
	"./Contract/Index.vue": 79351,
	"./Contract/Show": 69089,
	"./Contract/Show.vue": 69089,
	"./Contract/Show/Details": 99212,
	"./Contract/Show/Details.vue": 99212,
	"./Contract/Show/Files": 63055,
	"./Contract/Show/Files.vue": 63055,
	"./Contract/Show/Items": 11066,
	"./Contract/Show/Items.vue": 11066,
	"./Contract/Show/PartsList": 65604,
	"./Contract/Show/PartsList.vue": 65604,
	"./Contract/Statistic/Index": 10676,
	"./Contract/Statistic/Index.vue": 10676,
	"./Customer/Create": 40734,
	"./Customer/Create.vue": 40734,
	"./Customer/Index": 10762,
	"./Customer/Index.vue": 10762,
	"./Customer/Show/Angebote": 38981,
	"./Customer/Show/Angebote.vue": 38981,
	"./Customer/Show/ContractInformation": 5157,
	"./Customer/Show/ContractInformation.vue": 5157,
	"./Customer/Show/Uebersicht": 44466,
	"./Customer/Show/Uebersicht.vue": 44466,
	"./Dashboard": 73625,
	"./Dashboard.vue": 73625,
	"./Dashboard/Index": 76145,
	"./Dashboard/Index.vue": 76145,
	"./History/Index": 57819,
	"./History/Index.vue": 57819,
	"./History/Show": 59224,
	"./History/Show.vue": 59224,
	"./History/Show/Article": 56088,
	"./History/Show/Article.vue": 56088,
	"./History/Show/Fragenkatalog": 2304,
	"./History/Show/Fragenkatalog.vue": 2304,
	"./History/Show/Status": 29088,
	"./History/Show/Status.vue": 29088,
	"./History/Show/Uebersicht": 75627,
	"./History/Show/Uebersicht.vue": 75627,
	"./OfferData/Create": 81639,
	"./OfferData/Create.vue": 81639,
	"./OfferData/Edit": 7613,
	"./OfferData/Edit.vue": 7613,
	"./OfferData/Index": 57183,
	"./OfferData/Index.vue": 57183,
	"./OfferData/Show": 27662,
	"./OfferData/Show.vue": 27662,
	"./Organizations/Create": 30944,
	"./Organizations/Create.vue": 30944,
	"./Organizations/Edit": 44043,
	"./Organizations/Edit.vue": 44043,
	"./Organizations/Index": 15085,
	"./Organizations/Index.vue": 15085,
	"./Profile/Show": 57525,
	"./Profile/Show.vue": 57525,
	"./Questionnaire/Create": 18745,
	"./Questionnaire/Create.vue": 18745,
	"./Questionnaire/Empty": 41803,
	"./Questionnaire/Empty.vue": 41803,
	"./Questionnaire/Success": 69121,
	"./Questionnaire/Success.vue": 69121,
	"./Statistic/Index": 43657,
	"./Statistic/Index.vue": 43657,
	"./Teams/Create": 49360,
	"./Teams/Create.vue": 49360,
	"./Teams/Show": 63670,
	"./Teams/Show.vue": 63670,
	"./Todo/Index": 66715,
	"./Todo/Index.vue": 66715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83218;